import type { Analytics } from '@mwl/core-lib';

export const getOutrightAnalytics = (sportCategory?: string, isOpen?: boolean): Analytics => ({
  click: {
    eventName: isOpen ? 'sportOutright_sportCategory_dropdown_close' : 'sportOutright_sportCategory_dropdown_open',
    data: {
      sport_category: sportCategory,
    },
  },
});
